import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PageNotFound from "Samarth Module/pages/pageNotFound/pageNotFound";
import LTCPRouter from "../src/LTCP Module/routers/router";
import HeaderLayout from "Samarth Module/components/headerLayout/headerLayout";
import Capabilities from "Samarth Module/pages/capabilities/capabilities";
import { RefreshProvider } from "./utils/refreshContext";
import SamarthDashboard from "Samarth Module/pages/dashboard/dashboard";
import HandBook from "HandBook";

const MainRouterHandler = () => {
  return (
    <BrowserRouter>
      <RefreshProvider>
        <Routes>
          <Route path="/" element={<Capabilities />} />
          <Route path="/ltcp/*" element={<LTCPRouter />} />
          <Route path="/samarth/dashboard" element={<SamarthDashboard />} />
          <Route path="/samarth/*" element={<HeaderLayout />} />
          <Route path="/handbook/*" element={<HandBook />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </RefreshProvider>
    </BrowserRouter>
  );
};

export default MainRouterHandler;
